import React from 'react'

const Tooltip = (props) => {
  const {pos, text} = props
  return (
    <span className={`tooltip tooltip-${pos}`}>{text}</span>
  )
}

export default Tooltip